import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Alternativtext für dieses Bild fehlt',
    noAnswers: 'Keine Antwortmöglichkeit, bitte klicken Sie auf ‚Weiter‘, um fortzufahren.',
    placeholder: 'Bitte erläutern Sie ...',
    pleaseSelect: 'Bitte auswählen Sie...',
    rotateLandscape: 'Bitte deaktivieren Sie die Ausrichtungssperre auf Ihrem Handy und drehen Sie es ins Querformat.',
    rotatePortrait: 'Bitte drehen Sie Ihr Handy von Quer- in Hochformat.',
    ir: {
      selectWebCam:
        'Wählen Sie die Webcam aus (falls verfügbar) oder klicken Sie auf ‚Durchsuchen‘, um von Ihrem Gerät hochzuladen',
      noWebCam: 'Keine Webcam gefunden',
      accessCamUpload: 'ZUGRIFF KAMERA / UPLOAD',
      browse: 'DURCHSUCHEN',
      uploadPhoto: 'Laden Sie ein Foto hoch',
      instead: 'stattdessen',
      capture: 'ERFASSUNG',
      somethingWrong: 'Sorry, etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut',
      couldntRead: 'Leider wir konnten den Code nicht lesen!',
      couldntProcess: 'Leider konnten wir Ihr Bild nicht bearbeiten!',
      moveOn: 'Bitte versuchen Sie es erneut oder reichen Sie Ihr Foto ein und machen Sie weiter',
      tryAgain: 'Bitte versuchen Sie es erneut',
      dataReceived: 'Daten erhalten!',
      enterManually: 'Bitte versuchen Sie es erneut oder geben Sie die Daten manuell ein',
      positionQR:
        'Bitte positionieren Sie den QR-Code vor Ihrer Kamera, damit er in den roten Rahmen passt oder laden Sie ihn von Ihrem Computer hoch.',
      analyzing: 'Bild wird analysiert, bitte warten',
      submit: 'EINREICHEN',
      startOver: 'Von vorn anfangen',
      allDone: 'Fertig!',
      cantAnalyze:
        'Achtung - wir konnten dieses Bild nicht rendern. Bitte versuchen Sie, es erneut hochzuladen oder wählen Sie ein üblicheres Bildformat (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Es tut uns leid - dieses Dateiformat wird von uns nicht unterstützt. Bitte laden Sie ein unterstütztes Bildformat hoch (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Keine Webcam gefunden',
      uploadVideo: 'Ein Video hochladen',
      skip: 'Überspringen?',
      accessCamUpload: 'ZUGRIFF KAMERA / LADEN',
      browse: 'DURCHSUCHEN',
      instead: 'stattdessen',
      or: 'oder',
      stopRecording: 'Aufnahme anhalten',
      willBeStopped: 'Die Aufnahme stoppt nach 5 Minuten.',
      stopOnDone: 'Stoppen Sie die Aufnahme, wenn Sie fertig sind!',
      record: 'AUFZEICHNEN',
      somethingWrong: 'Sorry, etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut',
      microphone: 'Mikrofon',
      camera: 'Webcam',
      selectMicrophone: 'Wählen Sie Ihr Mikrofon aus',
      selectCam: 'Wählen Sie Ihre Webcam aus',
      submit: 'EINREICHEN',
      upload: 'HOCHLADEN',
      playback: 'Abspielen',
      stopPlayback: 'STOPPEN',
      startOver: 'Von vorn anfangen',
      allDone: 'Fertig!',
      alternativeRecordSpan:
        'Bitte laden Sie einen Videoclip von Ihrem Computer hoch.<br/>Alternativ können Sie &nbsp;',
      alrenativeRecordHref: 'das Video auch mit einer Webcam aufnehmen.',
      cantAnalyze:
        'Achtung - wir konnten dieses Video nicht rendern. Bitte versuchen Sie, es erneut hochzuladen oder wählen Sie ein üblicheres Videoformat (MP4, M4V, WEBPM)',
      wrongFormat:
        'Es tut uns leid - dieses Dateiformat wird von uns nicht unterstützt. Bitte laden Sie ein unterstütztes Videoformat hoch (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'WÄHLEN',
      pleaseChoose: 'Bitte wählen',
      this: 'DIES',
      one: 'eins',
      myChoice: 'Meine AUSWAHL'
    },
    hm: {
      addComment: 'Bitte fügen Sie im Folgenden einen Kommentar hinzu',
      commentMandatoryPlaceHolder: 'Bitte fügen Sie den erforderlichen Kommentar hinzu ... ',
      commentOptionalPlaceHolder: 'Bitte fügen Sie ggf. einen Kommentar hinzu ... ',
      dragPin: 'Zur Repositionierung ziehen (für präzisen Pin-Einsatz anklicken/antippen und festhalten).',
      removePin: 'Zum Löschen außerhalb des Bildes ziehen.',
      editComment: 'Klicken/Tippen Sie auf den Pin, um den Kommentar zu bearbeiten.',
      addPin:
        'Bitte ziehen Sie den Pin vom nachstehenden Bedienfeld an eine Bildstelle Ihrer Wahl und setzen Sie ihn dort.',
      addPins:
        'Bitte ziehen Sie die Pins vom nachstehenden Bedienfeld an eine Bildstelle Ihrer Wahl und setzen Sie sie dort.',
      leavePins: (minPoints, maxPoints) =>
        `Bitte setzen Sie mindestens ${minPoints}, aber nicht mehr als ${maxPoints} Pins pro Sorte.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Bitte setzen Sie mindestens ${minPoints}, aber nicht mehr als ${maxPoints} Pins.`,
      leavePinsWithOff: maxPoints =>
        `Bitte setzen Sie nicht mehr als ${maxPoints} Pins pro Sorte oder klicken Sie zum Überspringen auf „Weiter“.`,
      leavePinsPerPageWithOff: maxPoints =>
        `Bitte setzen Sie nicht mehr als ${maxPoints} Pins oder klicken Sie zum Überspringen auf „Weiter“.`,
      leavePinWithOff:
        'Bitte setzen Sie nicht mehr als 1 Pin pro Sorte oder klicken Sie zum Überspringen auf „Weiter“.',
      leavePinPerPageWithOff: 'Bitte setzen Sie nicht mehr als 1 Pin oder klicken Sie zum Überspringen auf „Weiter“.',
      leaveExactlyPin: 'Bitte setzen Sie 1 Pin pro Sorte.',
      leaveExactlyPinPerPage: 'Bitte setzen Sie 1 Pin.',
      leaveExactlyPins: maxPoints => `Bitte setzen Sie ${maxPoints} Pins pro Sorte.`,
      leaveExactlyPinsPerPage: maxPoints => `Bitte setzen Sie ${maxPoints} Pins.`,
      leaveComment: 'Geben Sie unterhalb des Bilds Ihren Kommentar ein.',
      noAnswers: 'Keine Antwortmöglichkeit. Bitte klicken Sie auf „Weiter“, um fortzufahren.',
      outOfPins: 'Sie haben keine Pins mehr',
      pinsBehavior:
        'Wenn Sie über das Bild navigieren, sehen Sie Bereiche, die mit einer einzelnen Pin-Markierung hervorgehoben werden.',
      clusters: 'Sie können Pins nur in diesen hervorgehobenen Bereichen platzieren.',
      contentAware: 'Sie können Pins innerhalb oder außerhalb der hervorgehobenen Bereiche platzieren.'
    },
    mp: {
      expand_note: 'Zum Vergrößern bitte mit dem Mauszeiger über das/die Bild/er fahren oder darauf klicken',
      rb_note: rows => `Bitte wählen Sie nur 1 Antwort für jeden ${rows ? 'nachstehenden' : ''} Punkt auswählen:`,
      cb_note: (min, max, _rows) => {
        if (min === max) {
          return `Bitte wählen Sie ${min !== 1 ? 'beliebige' : 'nur'} ${min} Antwort${
            min !== 1 ? 'en' : ''
          } pro Punkt aus:`
        } else if (min > 0 && max < 5000) {
          return `Bitte wählen Sie mindestens ${min} Antwort${
            min !== 1 ? 'en' : ''
          } aus, aber nicht mehr als ${max} pro Punkt aus:`
        } else if (5000 === max && min > 0) {
          return `Bitte wählen Sie mindestens ${min} Antwort${min !== 1 ? 'en' : ''} pro Punkt aus:`
        } else if (0 === min && max < 5000) {
          return `Bitte wählen Sie nicht mehr als ${max} Antwort${max !== 1 ? 'en' : ''} pro Punkt aus:`
        } else {
          return 'Bitte alle Zutreffenden auswählen:'
        }
      }
    },
    sh: {
      note: 'Klicken Sie auf ein Produkt, um es zu vergrößern und zu Ihrem virtuellen Einkaufskorb hinzuzufügen, wenn Sie es im Geschäft kaufen würden',
      amazonNote: 'Klicken Sie ein Produkt an, um es zu vergrößern und in Ihren virtuellen Warenkorb zu legen.',
      fullCart: 'Ihr Einkaufskorb ist voll!',
      qty: 'MGE',
      each: 'jede',
      items: 'artikel',
      next: 'WEITER',
      addToCart: 'ZUM EINKAUFSKORB HINZUFÜGEN',
      deleteFromCart: 'LÖSCHEN',
      emptyCard: 'Ihr Einkaufskorb ist leer',
      total: 'Einkaufskorb',
      clearCart: 'Einkaufskorb leeren',
      backToStore: 'Zurück zum Geschäft',
      na: 'Keine der obigen',
      maxCartCountError: max => `Bitte legen Sie nicht mehr als ${max} Produkte in Ihren Warenkorb`,
      scrollError: `Scrollen Sie bitte ganz nach links und rechts, um mit der Umfrage fortzufahren. `,
      maxSpentError: max => `Bitte geben Sie nicht mehr als ${max} aus.`,
      maxProductCountError: max =>
        `Bitte legen Sie für jedes Produkt nicht mehr als die Menge ${max} in Ihren Warenkorb.`
    },
    rb: {
      note: 'Bitte wählen Sie nur 1 Punkt:'
    },
    vo: {
      note: 'Bitte schauen Sie sich das Video bis zum Ende an'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Bitte alle Zutreffenden auswählen:'
        } else if (min === max) {
          return `Bitte wählen Sie ${min !== 1 ? 'any' : 'nur'} ${min} Punkt${min !== 1 ? 'e' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Bitte wählen Sie mindestens ${min} Punkt${min !== 1 ? 'e' : ''} aus, aber nicht mehr als ${max}:`
        } else if (5000 === max && min > 0) {
          return `Bitte wählen Sie mindestens ${min} Punkt${min !== 1 ? 'e' : ''} aus:`
        } else if (0 === min && max < 5000) {
          return `Bitte wählen Sie nicht mehr als ${max} Punkt${max !== 1 ? 'e' : ''}:`
        } else {
          return 'Bitte alle Zutreffenden auswählen:'
        }
      }
    },
    oe: {
      na: 'Unzutreffend',
      note: (min, max, optional) => {
        if (min === max) {
          return `Bitte geben Sie ${1 !== min ? 'beliebiges' : 'genau'} ${min} Zeichen${optional ? ' (optional)' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Bitte geben Sie mindestens ${min} Zeichen ein, aber nicht mehr als ${max}${
            optional ? ' (optional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Bitte geben Sie mindestens ${min} Zeichen ${optional ? ' ein (optional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Bitte geben Sie nicht mehr als ${max} Zeichen ${optional ? ' ein (optional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Bitte füllen Sie die folgenden Felder aus:'
    },
    mx: {
      note: 'Bitte verschieben Sie die markierten Schieberegler, um fortzufahren',
      dragSlider: 'Zum Beantworten nach links oder rechts ziehen'
    },
    psc: {
      dragLeftRight: 'Zum Beantworten nach links oder rechts ziehen'
    },
    ps: {
      note: value => `Bitte verteilen Sie die verbleibenden ${value} auf die unten gezeigten Möglichkeiten`,
      allDone: 'Fertig!',
      total: `Gesamt:`,
      dragSlider: 'Zum Beantworten nach links oder rechts ziehen'
    },
    cx: {
      note: 'Bitte tragen Sie Ihren Antwort ein, um die automatische Bildlauffunktion zu aktiveren oder wählen Sie sie manuell aus.'
    },
    ro: {
      note: 'Zur Neueinordnung nach oben oder unten ziehen:'
    },
    md: {
      note1:
        'Bitte klicken/tippen Sie auf das Element, das Ihnen am meisten zusagt<br/>Bei erneutem Anklicken/Antippen wird dieses gelöscht.',
      note2:
        'Bitte klicken/tippen Sie jetzt auf das Element, das Ihnen am wenigsten zusagt<br/>Bei erneutem Anklicken/Antippen wird dieses gelöscht.',
      note3:
        'Vielen Dank! Gehen Sie zur nächsten Frage über oder klicken/tippen<br/>Sie auf ein beliebiges, noch nicht ausgewähltes Element, um neu zu beginnen.'
    },
    aro: {
      note: 'Bitte wählen Sie für jedes Paar einen Artikel.'
    },
    wd: {
      note: 'Bitte achten Sie darauf, dass jeder folgende Wert größer ist als der vorherige.'
    },
    emd: {
      note: 'Bitte schauen Sie sich das Video bis zum Ende an',
      noAnswers: 'Keine Antwortmöglichkeit, bitte klicken Sie auf ‚Weiter‘, um fortzufahren.',
      start: 'Zum Starten klicken und halten',
      resume: 'Zum Fortsetzen klicken und gedrückt halten',
      continue: 'Sie sind bereit! <br /> Klicken Sie auf <strong>Weiter</strong>, um fortzufahren',
      continueMobile: 'Sie sind bereit! <br /> Zum Fortfahren HIER klicken',
      training: {
        session: 'Trainingssitzung',
        note: 'Bitte schließen Sie das Training ab',
        moveLeft: 'Bitte ziehen Sie das Rad ganz nach links',
        moveBottom: 'Bitte ziehen Sie das Rad nach ganz unten',
        moveRight: 'Bitte ziehen Sie jetzt das Rad ganz nach rechts',
        moveTop: 'Bitte ziehen Sie jetzt das Rad ganz nach oben',
        success: 'Gut gemacht!'
      }
    },
    sft: {
      noAnswers: 'Keine Antwortmöglichkeit, bitte klicken Sie auf ‚Weiter‘, um fortzufahren.',
      note: 'Bitte antworten Sie so schnell wie möglich mit der Antwort, die sich intuitiv richtig anfühlt',
      finish: 'Sie sind bereit! <br /> Bitte klicken Sie auf Weiter, um fortzufahren',
      training: {
        start:
          '<p>Bei dieser Frage werden Ihnen schnell verschiedene Wörter angezeigt und Ihre Konzentration ist gefragt. ' +
          'Sie müssen beim Antworten schnell reagieren.</p> <p>Bereit zum Trainieren?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tippen Sie auf "{buttonLeft}"`
            : (mouse ? `Klicken Sie auf "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Drücken Sie die "{keyBtnLeft}"-Taste` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tippen Sie auf "{buttonRight}"`
            : (mouse ? `Klicken Sie auf "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Drücken Sie die "{keyBtnRight}"-Taste` : ''),
        fail: () => 'Zu langsam',
        success: () => 'Toll!',
        finish: () =>
          '<p><strong> Ausgezeichnet!</strong></p><p> Bitte stellen Sie sicher, <br />' +
          ' dass Sie in den nächsten <br/> 2-3 Minuten nicht abgelenkt werden. </p><p>Klicken Sie auf Weiter, um zu starten, wenn Sie bereit sind. </p>'
      },
      buttons: {
        start: 'Start',
        yesno: {
          left: 'Ja',
          right: 'Nein'
        },
        matches: {
          left: 'Match',
          right: 'Kein Match'
        },
        fits: {
          left: 'Passend',
          right: 'Nicht passend'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
